import Badge from "../Badge";
import Icon from "../Icon";
import React from "react";
import ReactMarkdown from "react-markdown";
import { faLink } from "@fortawesome/free-solid-svg-icons";
import { loremIpsum } from "lorem-ipsum";
import moment from "moment";
import useTime from "../../hooks/useTime";

export interface ScheduleRowProps {
  title: string;
  link?: string;
  timeStart: Date;
  timeEnd: Date;
  description: string;
  isLast?: boolean;
}

const ScheduleRow = ({
  title,
  link,
  timeStart,
  timeEnd,
  description,
  isLast,
}: ScheduleRowProps) => {
  const now = useTime();

  return (
    <div className="flex justify-start">
      <div className="w-1/12">
        <div
          className="relative h-full"
          style={{
            top: "7px",
            paddingBottom: !isLast ? "6rem" : "",
          }}
        >
          <div className="w-2 h-2 bg-gray-300 rounded-full"></div>
          {!isLast ? (
            <div
              className="absolute top-0 bottom-0 w-px mt-2 bg-gray-300"
              style={{
                left: "3px",
              }}
            ></div>
          ) : null}
        </div>
      </div>
      <div className="w-4/12 max-w-xs pr-2 space-y-2">
        {link ? (
          <a href={link} target="_blank" rel="noopener noreferrer">
            <div className="flex items-center justify-start space-x-2 text-cream">
              <ReactMarkdown
                className="inline-block"
                source={title.replace(/\\n/g, "\n")}
              />
              <span className="inline-block text-xs">
                <Icon icon={faLink} />
              </span>
            </div>
          </a>
        ) : (
          <div className="text-cream">
            <ReactMarkdown source={title.replace(/\\n/g, "\n")} />
          </div>
        )}

        <div className="text-xs text-gray-400">
          {moment(timeStart).format("H:mm")} - {moment(timeEnd).format("H:mm")}
        </div>

        {now >= timeStart && now < timeEnd ? (
          <div className="pb-8">
            <Badge text="Live" />
          </div>
        ) : null}
      </div>

      <div className="w-full max-w-lg pb-8">
        {description ? (
          <ReactMarkdown source={description.replace(/\\n/g, "\n")} />
        ) : (
          loremIpsum({
            paragraphLowerBound: 1,
            paragraphUpperBound: 2,
            units: "paragraphs",
          })
        )}
      </div>
    </div>
  );
};
export default ScheduleRow;
